import React from "react";
import { Dialog, DialogContent } from "../../ui/dialog";
import styles from "./ContactModal.module.css";

const ContactModal = ({ isOpen, onClose, user }) => {
  if (!user) return null;

  const { contact_numbers = [] } = user;

  return (
    <Dialog open={isOpen} setOpen={onClose}>
      <DialogContent className={styles.modalContent}>
        <div className={styles.header}>
          <h2 className={styles.title}>Additional Phone Number</h2>
          <button
            type="button"
            className={styles.closeBtn}
            onClick={() => onClose()}
            aria-label="Close"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M7 7L17 17M17 7L7 17"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
              />
            </svg>
          </button>
        </div>

        <div className={styles.divider} />

        <div className={styles.body}>
          {contact_numbers.length > 0 ? (
            <ol className={styles.phoneList}>
              {contact_numbers.map((contact, index) => (
                <li key={contact.id ?? index} className={styles.phoneItem}>
                  {contact.number}
                </li>
              ))}
            </ol>
          ) : (
            <p className={styles.noContacts}>
              No additional contact information available.
            </p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ContactModal;